// ###### IMPORTS GENERAL
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowRightEndOnRectangleIcon, ArrowDownTrayIcon } from '@heroicons/react/24/solid';

// imports
import routes_web from "../../connections/routes_web";
import ModalInstallApp from "./moduleComponents/ModalInstallApp";

// ###### VIEW COMPONENT
const Welcome = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const searchParams = new URLSearchParams(location.search || '');
  const installParam = searchParams.get('install');
  const moduleParam = searchParams.get('module') || 'main';

  useEffect(() => {
    if (installParam === '1') {
      setShowMessage(true);
    }
  }, [installParam]);

  useEffect(() => {
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      setIsInstalled(true);
    }

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    });
  }, []);

  const handleInstallClick = async () => {
    if (isInstalled) return;
    setShowMessage(true);
  };

  const handleModalInstall = async () => {
    if (deferredPrompt) {
      await deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setDeferredPrompt(null);
        setIsInstalled(true);
        setShowMessage(false);
      }
    }
  };

  // ###### RETURN VIEW
  return (
    <div
      className="w-full bg-gray-900 text-white"
      style={{ height: 'calc(var(--vh, 1vh) * 100)' }}
    >
      <div className="container mx-auto h-full flex items-center justify-center relative px-4">
        {/* Content Wrapper */}
        <div className="relative z-10 bg-gray-800 rounded-2xl shadow-lg w-full max-w-4xl flex overflow-hidden h-[70vh]">
          
          {/* Login Button */}
          <div className="absolute top-4 right-4 z-20">
            <button
              onClick={() => navigate(routes_web.accounts_home)}
              className="px-4 py-2 border border-gray-400 text-gray-200 rounded hover:bg-gray-700"
            >
              <ArrowRightEndOnRectangleIcon className="h-6 w-6" />
            </button>
          </div>

          {/* Image Section */}
          <div
            className="w-2/5 sm:w-1/2 h-full bg-cover bg-center"
            style={{ backgroundImage: `url(${routes_web.img_welcome_bg})` }}
          ></div>

          {/* Text Section */}
          <div className="w-3/5 sm:w-1/2 p-6 sm:p-10 flex flex-col justify-center">
            <h1 className="text-3xl sm:text-5xl font-bold mb-6 text-gray-100">
              Quinas Ecosystem
            </h1>
            <p className="text-base sm:text-xl text-gray-300 mt-1">
              For life.
            </p>
            <p className="text-base sm:text-xl text-gray-300 mb-4">
              All under control, beyond Tech.
            </p>


            {/* Action Buttons */}
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
              <button
                onClick={handleInstallClick}
                disabled={isInstalled}
                className={`px-3 py-2 text-sm text-gray-100 font-medium rounded-lg shadow-md flex items-center justify-center gap-1.5 transition-all duration-300 border border-gray-700 border-[1px]
                   bg-gradient-to-r from-gray-800 via-gray-900 to-gray-900
                    ${isInstalled 
                     ? 'opacity-60 cursor-not-allowed'
                     : 'hover:bg-gradient-to-r hover:from-green-600 hover:via-green-700 hover:to-green-800 hover:scale-105 hover:border-green-500'
                    }`}
                 style={{
                   boxShadow: '0 2px 6px 0 rgba(30,30,30,0.2)',
                   borderColor: '#374151'
                 }}
              >
                <ArrowDownTrayIcon className="h-4 w-4" />
                <span className="tracking-wide">{isInstalled ? 'App Already Installed' : 'Install App'}</span>
              </button>
              <button
                onClick={() => navigate(routes_web.pages_register)}
                 className="px-3 py-2 text-sm text-gray-100 font-medium rounded-lg shadow-md flex items-center justify-center gap-1.5 border border-gray-700 border-[1px] bg-gradient-to-r from-gray-800 via-gray-900 to-gray-900 transition-all duration-300 hover:bg-gradient-to-r hover:from-green-600 hover:via-green-700 hover:to-green-800 hover:scale-105 hover:border-green-500"
                 style={{
                   boxShadow: '0 2px 6px 0 rgba(30,30,30,0.2)',
                   borderColor: '#374151'
                 }}
              >
                <span className="tracking-wide">Create Account</span>
              </button>
            </div>


          </div>
        </div>
      </div>

      {/* Install App Modal */}
      <ModalInstallApp
        isOpen={showMessage}
        onClose={() => setShowMessage(false)}
        onInstall={handleModalInstall}
        isInstalled={isInstalled}
        deferredPrompt={deferredPrompt}
        initialModule={moduleParam}
      />
    </div>
  );
};

export default Welcome;